import { RunDownloadImportInput } from '@/models/gen/graphql';
import { RunDownloadImportsDocument } from '@/api/queries';
import graphApi from '@/api';

const [fetchRunDownloadManifestImports] = graphApi(RunDownloadImportsDocument);

const runDownloadManifestImports = async (importId: string) => {
  const input: RunDownloadImportInput = { importIds: [importId] };
  const res = await fetchRunDownloadManifestImports({ input });
  return res?.runDownloadImport?.output;
};

export default runDownloadManifestImports;
